// -----------------------
// Product Customizations
// -----------------------

// DOM Ready
function documentReady(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

const cr = {
    variantsSelected: function(type){
        let variantSelectors;
        if (type === 'radio'){
            variantSelectors = document.querySelector('variant-radios');
            const fieldsets = variantSelectors.querySelectorAll('fieldset');
            let values = [];
            fieldsets.forEach(fieldset => {
                const inputs = fieldset.querySelectorAll('input');
                inputs.forEach(input => {
                    if (input.checked){
                        values.push(input.getAttribute('value'));
                    }

                });
            });
            return values;
        }
        if (type === 'select'){
            variantSelectors = document.querySelectorAll('variant-selects select');
            let values = [];
            variantSelectors.forEach(select => {
                const selectedOption = select.options[select.selectedIndex];
                values.push(selectedOption.value);
            });
            return values;
        }

    },
    updateSelectedPrice: function(variantsSelected){
        const compareAtPrice = parseInt(cr.matchingVariant(variants, variantsSelected).compare_at_price);
        let regularPrice = parseInt(cr.matchingVariant(variants, variantsSelected).price);
        const priceSaleElement = document.querySelector('.price__sale');
        const salePriceElement = priceSaleElement.querySelector('.price-item--sale');
        const compareElement = priceSaleElement.querySelector('s.price-item--regular');

        compareElement.innerHTML = '$' + compareAtPrice / 100;
        salePriceElement.innerHTML = '$' + regularPrice / 100;
    },
    variantsOnChange: function(type){
        let selectors;
        if (type === 'radio'){
            selectors = document.querySelectorAll('.product-form__input input[type="radio"]');
        }
        if (type === 'select'){
            selectors = document.querySelectorAll('.product-form__input select');
        }
        selectors.forEach(selector => {
            selector.addEventListener('change', event => {
                // Update Product Photo
                cr.updateProductPhoto(cr.matchingVariant(variants, cr.variantsSelected(type)).featured_media.preview_image.src);
                document.querySelector('input.product-variant-id').value = cr.matchingVariant(variants, cr.variantsSelected(type)).id;
                cr.updateSelectedPrice(cr.variantsSelected(type));
            });
        });
    },
    matchingVariant: function(variants, variantsSelected) {
        return variants.find(variant => {
            return variant.options.every((option, index) => {
                return option === variantsSelected[index];
            });
        });
    },
    updateProductPhoto: function(imageUrl){
        // Find slide with matching src
        const slickSlides = document.querySelectorAll('.slick-slide');
        slickSlides.forEach(slide => {
            const img = slide.querySelector('img');
            if (img) {
                const imgSrc = img.getAttribute('src');
                const protocolRemovedSrc = imageUrl.replace('https:', '');
                if (imgSrc === protocolRemovedSrc) {
                    let slideIndex = slide.getAttribute('data-slick-index');
                    // Use slickGoTo to go to that slide
                    $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', slideIndex);
                }
            }
        });
    },
    quantityChange: function(){
        const minButton = document.querySelector('.quantity-form .min');
        const plusButton = document.querySelector('.quantity-form .plus');
        const quantityInput = document.getElementById('Quantity');

        if(minButton) {
            minButton.addEventListener('click', event => {
                event.preventDefault();
                let quantity = parseInt(quantityInput.value);
                if (quantity > 1) {
                    quantity--;
                    quantityInput.value = quantity;
                }
            });
        }
        
        if(plusButton) {
            plusButton.addEventListener('click', event => {
                event.preventDefault();
                let quantity = parseInt(quantityInput.value);
                quantity++;
                quantityInput.value = quantity;
            });
        }
        
    },
    watchForRCWidget: function() {
        const widget = document.querySelector('.recharge-subscription-widget');

        if (widget) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                if (mutation.addedNodes) {
                    mutation.addedNodes.forEach((node) => {
                    if (node.classList && node.classList.contains('rc-widget')) {
                        // Element detected, stop observing and append bullet points
                        observer.disconnect();
                        cr.appendSubscriptionBullets(); // Replace with your logic
                    }
                    });
                }
                });
            });

            observer.observe(widget, { childList: true, subtree: true });
        }

    },
    appendSubscriptionBullets: function() {
        const bulletPoints = [
            'Delivered monthly',
            'Never run out of Mommy’s Bliss',
            'Skip, swap or cancel any time',
        ];
    
        const widget = document.querySelector('.recharge-subscription-widget');
        const bulletList = document.createElement('ul');
        bulletList.className = "rc-widget-list-details"
        bulletPoints.forEach((point) => {
            const bulletItem = document.createElement('li');
            bulletItem.textContent = point;
            bulletList.appendChild(bulletItem);
        });
    
        const learnMore = document.createElement("a");
        learnMore.setAttribute("href", "/pages/subscribe-save");
        learnMore.className="rc-widget-learm-more"
        learnMore.textContent = "Learn More"; // Set the text content if needed

        widget.appendChild(bulletList);
        widget.appendChild(learnMore);

        let rcProduct;
        for (const key in window.Recharge.widgets) {
            if (window.Recharge.widgets[key]) {
                rcProduct = window.Recharge.widgets[key].product;
                break; 
            }
        }
            
        const sellingPlanSelect = document.querySelector(".rc-selling-plans-dropdown__select")

        if(sellingPlanSelect) {
            const selectedGroup = rcProduct.selling_plan_groups.find(group => group.selling_plans[0].selling_plan_id === Number(sellingPlanSelect.value));
            const newText = selectedGroup?.selling_plans[0].order_interval_frequency === 1
            ? "Delivered monthly"
            : `Delivered every ${selectedGroup.selling_plans[0].order_interval_frequency} months`;
    
            document.querySelector(".rc-widget-list-details > li").textContent = `${newText}`
        }else {
            bulletList.style.display = "none";
            learnMore.style.display = "none";
        }
        
        if(sellingPlanSelect) {
            sellingPlanSelect.addEventListener('change', function(event) {
                // console.log("Window recahrge", window.Recharge)
                const selectedOption = event.target.options[event.target.selectedIndex];
                const selectedValue = Number(selectedOption.value);
                const selectedTitle = selectedOption.textContent;

                const selectedGroup = rcProduct.selling_plan_groups.find(group => group.selling_plans[0].selling_plan_id === selectedValue);
                const newText = selectedGroup.selling_plans[0].order_interval_frequency === 1
                ? "Delivered monthly"
                : `Delivered every ${selectedGroup.selling_plans[0].order_interval_frequency} months`;

                document.querySelector(".rc-widget-list-details > li").textContent = `${newText}`
            })
        }

        const purchaseOptionRadios = document.querySelectorAll('.recharge-subscription-widget input[name="purchaseOption"]');

        // Add a change event listener to each radio button
        purchaseOptionRadios.forEach((radio) => {
            radio.addEventListener("change", function () {
                if (radio.value === "onetime" && radio.checked) {
                    bulletList.style.display = "none";
                    learnMore.style.display = "none";
                } else {
                    bulletList.style.display = "block";
                    learnMore.style.display = "block";
                    cr.rcDropDownChange();
                }
            });
        });


    },

    rcDropDownChange: function() {
        const sellingPlanSelect = document.querySelector(".rc-selling-plans-dropdown__select")
        let rcProduct;
        for (const key in window?.Recharge?.widgets) {
            if (window.Recharge.widgets[key]) {
                rcProduct = window.Recharge.widgets[key].product;
                break; 
            }
        }
        if(sellingPlanSelect) {
            document.querySelector(".rc-widget-list-details > li").textContent = `Delivered monthly`
            sellingPlanSelect.addEventListener('change', function(event) {
                // console.log("Window recahrge", window.Recharge)
                const selectedOption = event.target.options[event.target.selectedIndex];
                const selectedValue = Number(selectedOption.value);
                const selectedTitle = selectedOption.textContent;

                const selectedGroup = rcProduct.selling_plan_groups.find(group => group.selling_plans[0].selling_plan_id === selectedValue);
                const newText = selectedGroup.selling_plans[0].order_interval_frequency === 1
                ? "Delivered monthly"
                : `Delivered every ${selectedGroup.selling_plans[0].order_interval_frequency} months`;

                document.querySelector(".rc-widget-list-details > li").textContent = `${newText}`
            })
        }
    }
}
// Watch Recharge Widget Insert
cr.watchForRCWidget()

// Page is Ready
documentReady(function() {
    // Variant Radios
    if ( document.querySelector('variant-radios') !== null ){
        // Detect changes to radio buttons
        cr.variantsOnChange('radio');
    }

    // Variant Selects
    if ( document.querySelector('variant-selects') !== null ){
        // Detect changes to select elements
        cr.variantsOnChange('select');
    }

    // Quantity Change
    cr.quantityChange();
    cr.rcDropDownChange();

});
